import React from 'react';

interface DirectionalArrowProps {
  heading?: number; // Heading in degrees (0 = North, 90 = East, 180 = South, 270 = West)
  size?: number;    // Size in pixels
  color?: string;   // Arrow color
}

const DirectionalArrow: React.FC<DirectionalArrowProps> = ({
  heading = 0,
  size = 72,
  color = '#991b1b'
}) => {
  return (
    <div 
      className="flex items-center justify-center"
      style={{
        transform: `rotate(${heading}deg)`,
        transformOrigin: 'center center',
        transition: 'transform 0.3s ease-out'
      }}
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 32 32"
        style={{
          filter: 'drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3))'
        }}
      >
        {/* Arrow head - pointing upward (north) by default with rounded edges */}
        <path
          d="M16 4 C16.5 4 21.5 21 22 22 C21.5 22.5 17 19 16 18 C15 19 10.5 22.5 10 22 C10.5 21 15.5 4 16 4 Z"
          fill={color}
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        {/* Inner highlight with rounded edges - reduced opacity for solid look */}
        <path
          d="M16 6 C16.3 6.2 19.7 19.5 20 20 C19.5 20.3 17 18 16 17 C15 18 12.5 20.3 12 20 C12.3 19.5 15.7 6.2 16 6 Z"
          fill="rgba(255, 255, 255, 0.2)"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};

export default DirectionalArrow;